import type { HelpArticle } from "@/lib/registrant-help";

export function HelpArticleBody({ article }: { article: HelpArticle }) {
  return (
    <div className="space-y-6 text-sm text-muted-foreground">
      {article.sections.map((section) => (
        <section key={section.heading}>
          <h3 className="font-semibold text-foreground mb-2">
            {section.heading}
          </h3>
          <div className="space-y-2">
            {section.blocks.map((block, index) => {
              const key = `${section.heading}-${index}`;
              if (block.type === "p") {
                return <p key={key}>{block.text}</p>;
              }
              const List = block.type === "ol" ? "ol" : "ul";
              return (
                <List
                  key={key}
                  className={
                    block.type === "ol"
                      ? "list-decimal pl-5 space-y-1"
                      : "list-disc pl-5 space-y-1"
                  }
                >
                  {block.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </List>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
}
